import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const baseResource = `${MERCATELY_API}/bsp/call_events`;
const model = abstractModel(baseResource);

export default model;
